import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IOfferStatus,
  IOfferStatusListRequest,
  OfferStatusState,
} from "@/types/offerStatus";
import CustomRequest from "../customRequest";

const actions: ActionTree<OfferStatusState, RootState> = {
  // async get({ commit }, id: number) {
  //   await CustomRequest.get<IPagination<IOfferStatus>>({
  //     uri: `/offertatus/${id}`,
  //     commit,
  //     target: "single",
  //   });
  // },

  async getList({ commit }, params: IOfferStatusListRequest) {
    await CustomRequest.get<IPagination<IOfferStatus>>({
      uri: "/offerStatus",
      params,
      commit,
      target: "pagination",
    });
  },
};

export default actions;
